// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"c8402ec8","150":"480899a3","210":"3d07d8d1","263":"ac68584b","488":"bab1e1b1","814":"d3263a73","871":"2b1fd49e","887":"c580a3ef"}[chunkId] + ".chunk.js";
};